<template>
  <div class="qbank-page">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-icon">
          <i class="fas fa-question-circle"></i>
        </div>
        <h1 class="hero-title">{{ $t("qbank.title") }}</h1>
        <p class="hero-subtitle">{{ $t("common.app_name") }}</p>
      </div>
      <!-- Leaderboard Button -->
      <router-link 
        :to="{ name: 'QBankLeaderboard' }" 
        class="leaderboard-hero-btn"
        :title="$t('qbank.leaderboard') || 'المتصدرين'"
      >
        <svg class="leaderboard-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="12" width="5" height="9" rx="1"/>
          <rect x="10" y="5" width="5" height="16" rx="1"/>
          <rect x="17" y="9" width="5" height="12" rx="1"/>
        </svg>
      </router-link>
      <div class="hero-decoration">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div
          v-if="isLoading == true"
          style="
            font-weight: 800;
            border-radius: 10px;
            padding: 50px;
            font-size: large;
            text-align: center;
            background: #73737326;
          "
          class="loader text-success"
        >
          {{ $t("common.loading") }}
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">{{ $t("common.please_login_to_continue") }}</h3>
            <span>
              <a href="login" class="btn btn-success">
                {{ $t("common.login") }} <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div
            class="col-md-12"
            v-if="isLoading == false && isLoggedIn == true"
          >
            <div class="row">
              <div class="col-xl-5">
                <!--begin::Engage widget 1-->
                <div class="card h-xl-80" dir="ltr">
                  <!--begin::Body-->
                  <div class="card-body d-flex flex-column flex-center">
                    <!--begin::Heading-->
                    <div class="mb-2">
                      <!--begin::Title-->
                      <h1 class="fw-semibold text-gray-800 text-center lh-lg">
                        {{ $t("qbank.title") }}
                        <br />
                        <span class="fw-bolder">
                          {{ $t("qbank.new_subscription") }}</span
                        >
                      </h1>
                      <!--end::Title-->
                      <!--begin::Illustration-->
                      <div class="py-10 text-center">
                        <img
                          src="assets/img/online.png"
                          class="theme-light-show w-150px"
                          alt=""
                        />
                        <img
                          src="assets/img/online.png"
                          class="theme-dark-show w-150px"
                          alt=""
                        />
                      </div>
                      <!--end::Illustration-->
                    </div>
                    <!--end::Heading-->
                    <!--begin::Links-->
                    <div class="text-center mb-1">
                      <!--begin::Link-->
                      <a class="subscribe-btn" href="qbank-plan">
                        <i class="fa fa-plus-circle"></i>
                        <span>{{ $t("qbank.new_subscription") }}</span>
                      </a>
                      <!--end::Link-->
                    </div>
                    <!--end::Links-->
                  </div>
                  <!--end::Body-->
                </div>
                <!--end::Engage widget 1-->
              </div>
              <div class="col-xl-7 mb-xl-10">
                <!--begin::List widget 20-->
                <div class="card h-xl-100">
                  <!--begin::Header-->
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bold text-dark">
                        {{ $t("qbank.my_subscriptions") }}</span
                      >
                      <span class="text-muted mt-1 fw-semibold fs-7">{{
                        $t("qbank.subscriptions_list")
                      }}</span>
                    </h3>
                    <!--begin::Toolbar-->

                    <!--end::Toolbar-->
                  </div>
                  <!--end::Header-->
                  <!--begin::Body-->
                  <!--begin::Body-->
                  <div class="card-body pt-6">
                    <!-- عرض البيانات -->
                    <SubscriptionsList :subscriptions="subscriptions" />
                  </div>
                  <!--end::Body-->

                  <!--end::Body-->
                </div>
                <!--end::List widget 20-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

import SubscriptionsList from "./SubscriptionsList.vue";

export default {
  name: "Home",
  components: {
    SubscriptionsList,
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isLoading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      currentStep: 1, // بداية في الخطوة 1
      selectedOption: "", // البيانات للـ select box
      textInput: "", // البيانات للـ input text
      numberInput: "", // البيانات للـ input number
      isChecked: false, // البيانات للـ checkbox
    };
  },
  mounted() {
    this.getSubscriptions();
  },
  methods: {
    async getSubscriptions() {
      this.loadingBalance = true;
      try {
        const response = await fetch(
          `${apiUrl}/profile/qbanks/subscription-plans`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 302 || response.redirected || !response.ok) {
          this.isLoggedIn = false;
          this.isLoading = false;
          return;
        }
        this.isLoggedIn = true;
        const data = await response.json();
        this.subscriptions = data.data;

        // تصنيف الاشتراكات
        this.expiredSubscriptions = this.subscriptions.filter(
          (subscription) => !subscription.is_active
        );
        this.activeSubscriptions = this.subscriptions.filter(
          (subscription) => subscription.is_active
        );
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      } finally {
        this.loadingBalance = false;
        this.isLoading = false;
      }
    },
    formatDate(date) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped>
/* ========== Main Page ========== */
.qbank-page {
  background: linear-gradient(180deg, #f8fffe 0%, #f0fdf4 100%);
  min-height: 100vh;
}

/* ========== Hero Section ========== */
.hero-section {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  padding: 50px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 30px 30px;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(0, 199, 68, 0.3);
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 2;
}

.hero-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  backdrop-filter: blur(10px);
  animation: float 3s ease-in-out infinite;
}

.hero-icon i {
  font-size: 35px;
  color: white;
}

.hero-title {
  color: white;
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 400;
}

/* Leaderboard Button in Hero */
.leaderboard-hero-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  z-index: 10;
  text-decoration: none;
}

.leaderboard-hero-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.08);
}

.leaderboard-hero-btn .leaderboard-icon {
  width: 26px;
  height: 26px;
  stroke: white;
}

[dir="rtl"] .leaderboard-hero-btn {
  right: auto;
  left: 15px;
}

.hero-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.circle-1 {
  width: 150px;
  height: 150px;
  top: -40px;
  right: -40px;
  animation: pulse 4s ease-in-out infinite;
}

.circle-2 {
  width: 100px;
  height: 100px;
  bottom: -20px;
  left: 10%;
  animation: pulse 5s ease-in-out infinite 1s;
}

.circle-3 {
  width: 70px;
  height: 70px;
  top: 30%;
  left: 5%;
  animation: pulse 6s ease-in-out infinite 2s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.3;
  }
}

/* ========== Content Container ========== */
#kt_app_content {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ========== Loading State ========== */
.loader {
  background: white !important;
  border-radius: 20px !important;
  padding: 60px 30px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
}

.loader .spinner-border {
  width: 50px !important;
  height: 50px !important;
}

/* ========== Not Logged In Card ========== */
.not-login {
  background: white !important;
  border-radius: 24px !important;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.06);
  padding: 50px 30px !important;
  text-align: center;
}

.not-login .icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.3);
}

.not-login .icon i {
  font-size: 32px;
  color: white;
}

.not-login h3 {
  color: #2d3748;
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 20px;
}

.not-login .btn-success {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%) !important;
  border: none !important;
  border-radius: 50px !important;
  padding: 12px 30px !important;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.3);
  transition: all 0.3s ease;
  color: white;
}

.not-login .btn-success i {
  color: white;
}

.not-login .btn-success:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(0, 199, 68, 0.4);
}

/* ========== Favorites Button ========== */
.favorites-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(0, 199, 68, 0.3);
  margin-bottom: 20px;
  cursor: pointer;
}

.favorites-btn i {
  color: white;
}

.favorites-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 199, 68, 0.4);
  color: white;
}

/* ========== Cards ========== */
.card {
  background: white !important;
  border: none !important;
  border-radius: 20px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 199, 68, 0.12);
}

/* New Subscription Card */
.col-xl-5 .card {
  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%) !important;
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
}

.col-xl-5 .card h1 {
  color: #2d3748 !important;
  font-size: 1.2rem !important;
  font-weight: 600 !important;
}

.col-xl-5 .card h1 span {
  color: #00c744 !important;
  font-size: 1.4rem !important;
  font-weight: 700 !important;
}

.col-xl-5 .card img {
  filter: drop-shadow(0 10px 25px rgba(0, 196, 68, 0.2));
  transition: transform 0.3s ease;
  max-width: 120px;
}

.col-xl-5 .card:hover img {
  transform: scale(1.05);
}

/* Subscribe Button */
.subscribe-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 199, 68, 0.3);
}

.subscribe-btn i {
  color: white;
}

.subscribe-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(0, 199, 68, 0.4);
  color: white;
}

/* ========== Subscriptions Card ========== */
.col-xl-7 .card {
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
}

.card-header {
  background: transparent !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
  padding: 18px 22px !important;
}

.card-label {
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  color: #2d3748 !important;
}

.card-title .text-muted {
  color: #718096 !important;
  font-size: 0.85rem;
}

.card-body {
  padding: 18px 22px !important;
}

/* ========== Responsive ========== */
@media (max-width: 991.98px) {
  .hero-section {
    padding: 40px 15px;
    border-radius: 0 0 20px 20px;
  }

  .hero-icon {
    width: 60px;
    height: 60px;
  }

  .hero-icon i {
    font-size: 26px;
  }

  .hero-title {
    font-size: 1.5rem;
  }

  .card {
    border-radius: 16px !important;
  }

  .not-login {
    padding: 35px 20px !important;
  }

  .subscribe-btn,
  .favorites-btn {
    padding: 10px 18px;
    font-size: 0.85rem;
  }
}

/* ========== Dark Mode Support ========== */
[data-bs-theme="dark"] .qbank-page,
[data-theme="dark"] .qbank-page,
.dark .qbank-page {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
}

[data-bs-theme="dark"] .hero-section,
[data-theme="dark"] .hero-section,
.dark .hero-section {
  background: linear-gradient(135deg, #0f5132 0%, #0a3622 100%);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

[data-bs-theme="dark"] .loader,
[data-theme="dark"] .loader,
.dark .loader {
  background: #1e293b !important;
  color: #4ade80 !important;
}

[data-bs-theme="dark"] .not-login,
[data-theme="dark"] .not-login,
.dark .not-login {
  background: #1e293b !important;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.3);
}

[data-bs-theme="dark"] .not-login h3,
[data-theme="dark"] .not-login h3,
.dark .not-login h3 {
  color: #f1f5f9;
}

[data-bs-theme="dark"] .not-login .icon,
[data-theme="dark"] .not-login .icon,
.dark .not-login .icon {
  background: linear-gradient(135deg, #0f5132 0%, #0a3622 100%);
}

[data-bs-theme="dark"] .card,
[data-theme="dark"] .card,
.dark .card {
  background: #1e293b !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(255, 255, 255, 0.05) !important;
}

[data-bs-theme="dark"] .col-xl-5 .card,
[data-theme="dark"] .col-xl-5 .card,
.dark .col-xl-5 .card {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;
  border-color: rgba(0, 199, 68, 0.15) !important;
}

[data-bs-theme="dark"] .col-xl-5 .card h1,
[data-theme="dark"] .col-xl-5 .card h1,
.dark .col-xl-5 .card h1 {
  color: #f1f5f9 !important;
}

[data-bs-theme="dark"] .col-xl-5 .card h1 span,
[data-theme="dark"] .col-xl-5 .card h1 span,
.dark .col-xl-5 .card h1 span {
  color: #4ade80 !important;
}

[data-bs-theme="dark"] .card-header,
[data-theme="dark"] .card-header,
.dark .card-header {
  background: transparent !important;
  border-bottom-color: rgba(255, 255, 255, 0.08) !important;
}

[data-bs-theme="dark"] .card-label,
[data-theme="dark"] .card-label,
.dark .card-label {
  color: #f1f5f9 !important;
}

[data-bs-theme="dark"] .card-title .text-muted,
[data-theme="dark"] .card-title .text-muted,
.dark .card-title .text-muted {
  color: #94a3b8 !important;
}

[data-bs-theme="dark"] .favorites-btn,
[data-theme="dark"] .favorites-btn,
.dark .favorites-btn {
  background: linear-gradient(135deg, #0f5132 0%, #0a3622 100%);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

[data-bs-theme="dark"] .subscribe-btn,
[data-theme="dark"] .subscribe-btn,
.dark .subscribe-btn {
  background: linear-gradient(135deg, #0f5132 0%, #0a3622 100%);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}
</style>
